import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9af37c70"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "消息公告", -1))
const _hoisted_2 = ["innerHTML"]

import {DesktopOutlined} from '@ant-design/icons-vue';
import { OioModal, OioButton } from '@kunlun/vue-ui-antd';
import {NoticeItem} from "@/mask";
import {computed, onMounted, ref} from "vue";

interface IProps {
  newNotice: any;
  hasNewNotice: boolean;
  jump: (item: string) => void;
  visible: boolean;
  ignore: () => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PCNotice',
  props: {
    newNotice: null,
    hasNewNotice: { type: Boolean },
    jump: null,
    visible: { type: Boolean },
    ignore: null
  },
  setup(__props: any) {

const props = __props as { newNotice: any, hasNewNotice: boolean, jump: (item: string) => void, visible: boolean, ignore: () => void }



const showNotice = ref(true );

const batchEditModalVisible = computed(() => {
  // console.log('showNotice', props.newNotice)
  return showNotice.value && props.visible && props.newNotice && props.newNotice.title
})


const jumpTo= () => {
  showNotice.value = false;
  props.jump("props");
}

const ignore= () => {
  showNotice.value = false;
  props.ignore();
}

const toNotice= () => {
  props.jump("notice");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "pc-mall",
          onClick: toNotice
        }, [
          _createVNode(_unref(DesktopOutlined)),
          _hoisted_1
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(OioModal), {
      visible: _unref(batchEditModalVisible),
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(batchEditModalVisible) ? (batchEditModalVisible).value = $event : null)),
      title: "公告通知",
      width: "medium",
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), { onClick: ignore }, {
          default: _withCtx(() => [
            _createTextVNode("不再提示")
          ]),
          _: 1
        }),
        (__props.newNotice.isJump)
          ? (_openBlock(), _createBlock(_unref(OioButton), {
              key: 0,
              onClick: jumpTo
            }, {
              default: _withCtx(() => [
                _createTextVNode("跳转")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showNotice.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("h2", null, _toDisplayString(__props.newNotice.title), 1),
          _createElementVNode("div", {
            innerHTML: __props.newNotice.content
          }, null, 8, _hoisted_2)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})